import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ga4-connections")({
  component: lazyRouteComponent(() => import("./-pages/admin.ga4-connections")),
  head: () => ({
    meta: [
      { title: "GA4 Connections — Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
